import { Image } from '@nextui-org/react';
import { Flex } from '@chakra-ui/react';
import { googleLogout } from '@react-oauth/google';
import useAuth from '../../hooks/useAuth/useAuth';
import { useNavigate } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import { extensionsRoutes } from '../../pages/Routes';
import LogoutIcon from '@mui/icons-material/Logout';

const HeaderWeb = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  const logout = () => {
    googleLogout();
    navigate(extensionsRoutes.Logout);
  };

  if (isEmpty(auth)) return <></>;

  return (
    <header className="bg-primary-100 d-flex sticky top-0 z-40 flex h-16 items-center justify-between gap-8 pl-4 pr-8 py-4 xl:pl-32 xl:pr-8 text-white">
      <div className="flex items-center justify-between">
        <Image
          className="h-8 rounded-none"
          src="/images/miva-mobile-logo.png"
          alt="miva-logo"
        />
      </div>
      <Flex gap="8px" alignItems="center" justifyContent="flex-end">
        <div className="flex-end flex items-center gap-4">
          <Image
            className=""
            src="/images/profiles/avatar-profile.png"
            width={45}
            height={45}
            alt="avatar-profile"
          />
        </div>
        <LogoutIcon onClick={() => logout()} />
      </Flex>
    </header>
  );
};

export default HeaderWeb;
